import { render, staticRenderFns } from "./MenuSelects.vue?vue&type=template&id=567b14d1&"
import script from "./MenuSelects.vue?vue&type=script&lang=js&"
export * from "./MenuSelects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports